export default "__VITE_ASSET__CxzcNl8X__"